﻿import { replaceByIndex } from '../../utils/string';

interface IInputGroup {
    pattern: 'M' | 'd' | 'y',
    startPosition: number,
    endPosition: number
}

export class DatePickerMask {
    /**
     * value of input box
     */
    inputValue = '';
    /**
     * selection start
     */
    startPosition = 0;
    /**
     * selection end
     */
    endPosition = 0;
    currentPosition = 0;
    currentGroupIdx = 0;
    inputGroups: IInputGroup[] = [];
    /**
     * 
     * @param format date format, eg: MM/dd/yyyy
     */
    constructor(private format: string) {
        // use the format as mask
        this.inputValue = format;
        this.initInputGroup(format);
        this.resetGroupPosition();
    }

    initInputGroup(format: string):void {
        let currentPattern = format[0];
        let startPosition = 0;
        let endPosition = 0;
        for (let i = 1; i < format.length; i++) {
            if (format[i] !== currentPattern) {
                //new group
                if (currentPattern === 'M' || currentPattern === 'd' || currentPattern === 'y') {
                    this.inputGroups.push({
                        pattern: currentPattern,
                        startPosition: startPosition,
                        endPosition: endPosition
                    });
                } else {
                    // not a input group
                }

                startPosition = i;
                endPosition = i;
                currentPattern = format[i];
            } else {
                endPosition = i;
            }

            if (i === format.length - 1) {
                //last row
                //new group
                if (currentPattern === 'M' || currentPattern === 'd' || currentPattern === 'y') {
                    this.inputGroups.push({
                        pattern: currentPattern,
                        startPosition: startPosition,
                        endPosition: endPosition
                    });
                } else {
                    // not a input group
                }
            }
        }
    }

    setValue(value: string):void {
        this.inputValue = value;
    }

    /**
     * happened on keydown event
     * @param key event.key
     */
    sendKey(key: string):void {
        if (key === 'ArrowRight') {
            this.moveToNextInputGroup();
            return;
        }

        if (key === 'ArrowLeft') {
            this.moveToPreviousInputGroup();
            return;
        }

        if (key === 'Backspace' || key === 'Delete') {
            this.cleanCurrentGroupValue();
            return;
        }


        const keyNum = Number(key);
        if (isNaN(keyNum) === false) {
            const currentInputGroup = this.inputGroups[this.currentGroupIdx];
            const currentPattern = currentInputGroup.pattern;
            let replacedValue = '';
            if (
                (currentPattern === 'M' && keyNum > 1
                    && this.currentPosition === this.inputGroups[this.currentGroupIdx].startPosition
                    && this.currentPosition < this.inputGroups[this.currentGroupIdx].endPosition) ||
                (currentPattern === 'd' && keyNum > 3
                    && this.currentPosition === this.inputGroups[this.currentGroupIdx].startPosition
                    && this.currentPosition < this.inputGroups[this.currentGroupIdx].endPosition)
            ) {
                //add month prefix 0
                replacedValue = replaceByIndex(this.inputValue, '0', this.currentPosition);
                this.moveToNextInputPosition();
                replacedValue = replaceByIndex(replacedValue, String(key), this.currentPosition);
            } else {
                replacedValue = replaceByIndex(this.inputValue, String(key), this.currentPosition);
            }

            const newGroupValue = this.getCurrentGroupValue(replacedValue);
            const replacedNum = Number(newGroupValue);
            if (isNaN(replacedNum) === false) {
                if (currentPattern === 'M') {
                    if (
                        (replacedNum > 0 && replacedNum <= 12)
                        ||
                        (keyNum === 0 && this.currentPosition === this.inputGroups[this.currentGroupIdx].startPosition)
                    ) {
                        this.inputValue = replacedValue;
                        this.moveToNextInputPosition();
                    }
                } else if (currentPattern === 'd') {
                    if (
                        (replacedNum > 0 && replacedNum <= 31)
                        ||
                        (keyNum === 0 && this.currentPosition === this.inputGroups[this.currentGroupIdx].startPosition)
                    ) {
                        this.inputValue = replacedValue;
                        this.moveToNextInputPosition();
                    }
                } else if (currentPattern === 'y') {
                    this.inputValue = replacedValue;
                    this.moveToNextInputPosition();
                }
            } else {
                this.inputValue = replacedValue;
                this.moveToNextInputPosition();
            }
        }
    }

    private moveToNextInputPosition() {
        if (this.currentPosition < this.inputGroups[this.currentGroupIdx].endPosition) {
            this.currentPosition++;
        } else {
            this.moveToNextInputGroup();
        }
    }

    private moveToNextInputGroup() {
        if (this.currentGroupIdx < this.inputGroups.length - 1) {
            this.currentGroupIdx++;
            this.resetGroupPosition();
        }
    }

    private moveToPreviousInputGroup() {
        if (this.currentGroupIdx > 0) {
            this.currentGroupIdx--;
            this.resetGroupPosition();
        }
    }

    resetGroupPosition():void {
        this.startPosition = this.inputGroups[this.currentGroupIdx].startPosition;
        this.endPosition = this.inputGroups[this.currentGroupIdx].endPosition;
        this.currentPosition = this.startPosition;
    }

    resetAllPostion():void {
        this.currentGroupIdx = 0;
        this.resetGroupPosition();
    }

    clean():void {
        this.inputValue = this.format;
        this.resetAllPostion();
    }

    setPosition(position: number):void {
        for (let i = 0; i < this.inputGroups.length; i++) {
            if (position >= this.inputGroups[i].startPosition &&
                position <= this.inputGroups[i].endPosition) {
                this.currentGroupIdx = i;
                this.resetGroupPosition();
            }
        }
    }


    private getCurrentGroupValue(input: string) {
        const currentInputGroup = this.inputGroups[this.currentGroupIdx];
        return input.substring(currentInputGroup.startPosition, currentInputGroup.endPosition + 1);
    }

    private cleanCurrentGroupValue() {
        const currentInputGroup = this.inputGroups[this.currentGroupIdx];
        let newValue = this.inputValue.substring(0, currentInputGroup.startPosition);
        for (let i = currentInputGroup.startPosition; i <= currentInputGroup.endPosition; i++) {
            newValue += currentInputGroup.pattern;
        }
        newValue += this.inputValue.substring(currentInputGroup.endPosition + 1);
        this.inputValue = newValue;
        this.resetGroupPosition();
    }
}